import { getPathRegexpFromEmmaUrl } from '@axa-asia/utils';

const subPath = 'referral-programme';

const paths = {
  REFERRAL_FORM: `${subPath}/referral-form/\${campaignKey}`,
  SUCCESS: `${subPath}/success`,
  ERROR: `${subPath}/error/\${status}`,
};

export const PATH = {
  ...paths,
  REGEXP: Object.keys(paths).reduce(
    (acc, key) => ({
      ...acc,
      [key]: getPathRegexpFromEmmaUrl(paths[key]),
    }),
    {},
  ) as typeof paths,
};

// console.log('PATH:', PATH);

export default PATH;
